import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const quitAction = createAsyncThunk(
    'quit',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/total-missionqualified`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const quitSlice = createSlice({
    name: 'quit',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(quitAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(quitAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(quitAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const quitReducer = quitSlice.reducer
